export enum MenuEnum {
  Sent,
  Inbox
}